import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeavyPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.60207 14H8.38757V8.38757H14V5.60207H8.38757V0H5.60207V5.60207H0V8.38757H5.60207V14Z",
		fill: "#ACB2B9"
	})
});
export default SvgHeavyPlus;
